import { Grid, Container } from "@mui/material";
import ButtonNav from "../components/General/ButtonNav";
import { useAuth } from "../context/AuthContext";

import TableChartRoundedIcon from "@mui/icons-material/TableChartRounded";
import DriveFolderUploadRoundedIcon from "@mui/icons-material/DriveFolderUploadRounded";
import AttachmentRoundedIcon from "@mui/icons-material/AttachmentRounded";
import AssessmentRoundedIcon from "@mui/icons-material/AssessmentRounded";
import CloudUploadRoundedIcon from "@mui/icons-material/CloudUploadRounded";

export default function LegalFileAttachment() {
  const { hasPermission } = useAuth();

  return (
    <Container maxWidth="lg" sx={{ mt: 4 }}>
      <Grid container spacing={2} sx={{ mt: 2 }}>
        {hasPermission("cargar archivos planillas aportes expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Planillas de Aportes"
              subtitle="Cargar planillas de aportes de expedientes"
              icon={<TableChartRoundedIcon />}
              color="#2563eb"
              to="/legalFile/upload/aportes"
            />
          </Grid>
        )}

        {hasPermission("generar multiples archivos adjuntos expediente") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Gestionar Escritos"
              subtitle="Generar y gestionar escritos de expedientes"
              icon={<DriveFolderUploadRoundedIcon />}
              color="#0ea5e9"
              to="/legalFile/attachments/generate/upload"
            />
          </Grid>
        )}

        {hasPermission("subir escritos en linea sac") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Subir Escritos a SAC"
              subtitle="Subida masiva en línea al portal SAC"
              icon={<CloudUploadRoundedIcon />}
              color="#3ad8ed"
              to="/legalFile/attachments/upload/sac"
            />
          </Grid>
        )}

        {hasPermission("archivos adjuntos expedientes") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Escritos de Expedientes"
              subtitle="Gestionar escritos de expedientes"
              icon={<AttachmentRoundedIcon />}
              color="#10b981"
              to="/legalFile/attachments/manager"
            />
          </Grid>
        )}

        {hasPermission("reportes archivos adjuntos expedientes") && (
          <Grid size={{ xs: 12, sm: 6, md: 4, lg: 3 }}>
            <ButtonNav
              title="Reportes Escritos"
              subtitle="Generar reportes de escritos de expedientes"
              icon={<AssessmentRoundedIcon />}
              color="#8b5cf6"
              to="/legalFile/attachments/report"
            />
          </Grid>
        )}

      </Grid>
    </Container>
  );
}
